import HtmlElement from './HtmlElement';
import { CountUp } from 'countup.js';

/**
 * Facts
 *
 * @return Array
 */
const Facts = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		FACTS: '.facts',
		FACT: '.fact',
		HEADLINE: '.fact-headline'
	};

	/**
	 * Facts
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Facts extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.$facts = this.$element.find(Selector.FACT);
			const shouldAnimate = this.$element.data('animate-numbers') === 1;

			if (shouldAnimate) {
				this.$facts.each((i, fact) => {
					const $headline = $(fact).find(Selector.HEADLINE);
					const isNumber = !isNaN($headline.text());

					if (isNumber) {
						const counter = new CountUp(
							$headline.get(0),
							parseInt($headline.data('value')),
							{
								separator: '.'
							}
						);
						counter.start();
					}
				});
			}
		}
	}

	return Facts._getElements(Selector.FACTS, Facts);
})();

export default Facts;
